import React from 'react';
import { AnalyticsCategoryProvider, Categories } from '@app/analytics';
import { SpecialOfferBanner, MainDashboardPage, PageTitle } from 'components';
import { Dashboard } from './Dashboard';
import { NewFeatureBanner } from 'components/NewFeatureBanner';

export const Billing = () => {
  return (
    <AnalyticsCategoryProvider category={Categories.BILLING}>
      <PageTitle title="Billing" />
      <MainDashboardPage>
        <SpecialOfferBanner />
        <NewFeatureBanner />
        <Dashboard />
      </MainDashboardPage>
    </AnalyticsCategoryProvider>
  );
};
